module.exports = __webpack_public_path__ + "static/media/chevron-back.b3ec6223.svg";